import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getBrandListSaga = createAction(
  "GET_BRAND",
  ({ payload, params }: SagaActionParams<Type.BrandDto[]>) => ({
    payload,
    url: "/api/admin/brands/parentbrands" + (params ? params : ""),
  })
);

export const getSubBrandListByParentIdSaga = createAction(
  "GET_SUBBRANDS",
  ({ payload, params, id }: SagaActionParams<Type.BrandDto[]>) => ({
    payload,
    url: "/api/admin/brands/subbrands/" + id + (params ? params : ""),
  })
);
export const getBrandDetailsSaga = createAction(
  "GET_BRAND_DETAILS",
  ({ payload, id }: SagaActionParams<Type.BrandDetailDto>) => ({
    payload,
    url: "/api/admin/brands/" + id,
  })
);
export const createBrandSaga = createAction(
  "CREATE_BRAND",
  ({ payload, body }: SagaActionParams<Type.BrandDto>) => ({
    payload,
    url: "/api/admin/brands",
    body,
  })
);
export const updateBrandSaga = createAction(
  "UPDATE_BRAND",
  ({ payload, id, body }: SagaActionParams<Type.BrandDto>) => ({
    payload,
    url: "/api/admin/brands/" + id,
    body,
  })
);
export const deleteBrandSaga = createAction(
  "DELETE_BRAND",
  ({ payload, id }: SagaActionParams<Type.BrandDto>) => ({
    payload,
    url: "/api/admin/brands/" + id,
  })
);

const brandsSaga = [
  takeLatest<any>(
    getSubBrandListByParentIdSaga.toString(),
    (payload: SagaGenericParams<Type.BrandDto[]>) =>
      getSaga<Type.BrandDto[]>(payload)
  ),
  takeLatest<any>(
    getBrandListSaga.toString(),
    (payload: SagaGenericParams<Type.BrandDto[]>) =>
      getSaga<Type.BrandDto[]>(payload)
  ),
  takeLatest<any>(
    getBrandDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.BrandDetailDto>) =>
      getSaga<Type.BrandDetailDto>(payload)
  ),
  takeLatest<any>(
    createBrandSaga.toString(),
    (payload: SagaGenericParams<Type.BrandDto>) =>
      postSaga<Type.BrandDto>(payload)
  ),
  takeLatest<any>(
    updateBrandSaga.toString(),
    (payload: SagaGenericParams<Type.BrandDto>) =>
      putSaga<Type.BrandDto>(payload)
  ),
  takeLatest<any>(
    deleteBrandSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<Type.BrandDto>(payload)
  ),
];

export default brandsSaga;
